import {mapMutations} from "vuex";

const mapFunctionsMixin = {
    methods: {
        ...mapMutations({}),

        loadMapImages(map, loadIssues = true) {
            map.loadImage(
                require("@/assets/icons/ic_marker_asset_lbl.png"),
                (error, image) => {
                    if (error) throw error;
                    // map.addImage('asset_blue', image);
                    if (!map.hasImage('asset_blue_lbl')) {
                        map.addImage('asset_blue_lbl', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if (loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_asset_lbl_issue.png"),
                    (error, image) => {
                        if (error) throw error;
                        if (!map.hasImage('asset_blue_lbl_issue')) {
                            map.addImage('asset_blue_lbl_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                // require("@/assets/icons/ic_marker_asset_cluster_multiple.png"),
                require("@/assets/icons/ic_marker_asset_cluster_single.png"),
                (error, image) => {
                    if (!map.hasImage('asset_blue_cluster')) {
                        map.addImage('asset_blue_cluster', image, {
                            // content: [10, 5, 54, 18],
                            // stretchX: [[12, 13], [52, 53]],
                            // stretchY: [[10, 11]],
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if (loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_asset_cluster_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('asset_blue_cluster_issue')) {
                            map.addImage('asset_blue_cluster_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_asset_leaf.png"),
                (error, image) => {
                    if (!map.hasImage('asset_leaf')) {
                        map.addImage('asset_leaf', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
            map.loadImage(
                require("@/assets/icons/ic_marker_asset_leaf_issue.png"),
                (error, image) => {
                    if (!map.hasImage('asset_leaf_issue')) {
                        map.addImage('asset_leaf_issue', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })}
            map.loadImage(
                require("@/assets/icons/ic_marker_dumpster_cluster.png"),
                (error, image) => {
                    if (!map.hasImage('dumpster_cluster')) {
                        map.addImage('dumpster_cluster', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_dumpster_cluster_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('dumpster_cluster_issue')) {
                            map.addImage('dumpster_cluster_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_dumpster_lbl.png"),
                (error, image) => {
                    if (!map.hasImage('dumpster_lbl')) {
                        map.addImage('dumpster_lbl', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_dumpster_lbl_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('dumpster_lbl_issue')) {
                            map.addImage('dumpster_lbl_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_dumpster_leaf.png"),
                (error, image) => {
                    if (!map.hasImage('dumpster_leaf')) {
                        map.addImage('dumpster_leaf', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_dumpster_leaf_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('dumpster_leaf_issue')) {
                            map.addImage('dumpster_leaf_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_greasetrap_cluster.png"),
                (error, image) => {
                    if (!map.hasImage('greasetrap_cluster')) {
                        map.addImage('greasetrap_cluster', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_greasetrap_cluster_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('greasetrap_cluster_issue')) {
                            map.addImage('greasetrap_cluster_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_greasetrap_lbl.png"),
                (error, image) => {
                    if (!map.hasImage('greasetrap_lbl')) {
                        map.addImage('greasetrap_lbl', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_greasetrap_lbl_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('greasetrap_lbl_issue')) {
                            map.addImage('greasetrap_lbl_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_greasetrap_leaf.png"),
                (error, image) => {
                    if (!map.hasImage('greasetrap_leaf')) {
                        map.addImage('greasetrap_leaf', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_greasetrap_leaf_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('greasetrap_leaf_issue')) {
                            map.addImage('greasetrap_leaf_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_handwash_lbl.png"),
                (error, image) => {
                    if (!map.hasImage('handwash_lbl')) {
                        map.addImage('handwash_lbl', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_handwash_lbl_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('handwash_lbl_issue')) {
                            map.addImage('handwash_lbl_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_handwash_cluster.png"),
                (error, image) => {
                    if (!map.hasImage('handwash_cluster')) {
                        map.addImage('handwash_cluster', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_handwash_cluster_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('handwash_cluster_issue')) {
                            map.addImage('handwash_cluster_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_handwash_leaf.png"),
                (error, image) => {
                    if (!map.hasImage('handwash_leaf')) {
                        map.addImage('handwash_leaf', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_handwash_leaf_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('handwash_leaf_issue')) {
                            map.addImage('handwash_leaf_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_generic_cluster.png"),
                (error, image) => {
                    if (!map.hasImage('generic_cluster')) {
                        map.addImage('generic_cluster', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_generic_cluster_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('generic_cluster_issue')) {
                            map.addImage('generic_cluster_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_generic_lbl.png"),
                (error, image) => {
                    if (!map.hasImage('generic_lbl')) {
                        map.addImage('generic_lbl', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_generic_lbl_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('generic_lbl_issue')) {
                            map.addImage('generic_lbl_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_generic_leaf.png"),
                (error, image) => {
                    if (!map.hasImage('generic_leaf')) {
                        map.addImage('generic_leaf', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_generic_leaf_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('generic_leaf_issue')) {
                            map.addImage('generic_leaf_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_trailer_leaf.png"),
                (error, image) => {
                    if (!map.hasImage('trailer_leaf')) {
                        map.addImage('trailer_leaf', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_trailer_leaf_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('trailer_leaf_issue')) {
                            map.addImage('trailer_leaf_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_trailer_lbl.png"),
                (error, image) => {
                    if (!map.hasImage('trailer_lbl')) {
                        map.addImage('trailer_lbl', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_trailer_lbl_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('trailer_lbl_issue')) {
                            map.addImage('trailer_lbl_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_trailer_cluster.png"),
                (error, image) => {
                    if (!map.hasImage('trailer_cluster')) {
                        map.addImage('trailer_cluster', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_trailer_cluster_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('trailer_cluster_issue')) {
                            map.addImage('trailer_cluster_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_tank_leaf.png"),
                (error, image) => {
                    if (!map.hasImage('tank_leaf')) {
                        map.addImage('tank_leaf', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_tank_leaf_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('tank_leaf_issue')) {
                            map.addImage('tank_leaf_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_tank_lbl.png"),
                (error, image) => {
                    if (!map.hasImage('tank_lbl')) {
                        map.addImage('tank_lbl', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_tank_lbl_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('tank_lbl_issue')) {
                            map.addImage('tank_lbl_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
            map.loadImage(
                require("@/assets/icons/ic_marker_tank_cluster.png"),
                (error, image) => {
                    if (!map.hasImage('tank_cluster')) {
                        map.addImage('tank_cluster', image, {
                            content: [9, 5, 57, 18],
                            stretchX: [[10, 11], [55, 56]],
                            stretchY: [[10, 11]],
                        });
                    }
                })
            if(loadIssues) {
                map.loadImage(
                    require("@/assets/icons/ic_marker_tank_cluster_issue.png"),
                    (error, image) => {
                        if (!map.hasImage('tank_cluster_issue')) {
                            map.addImage('tank_cluster_issue', image, {
                                content: [9, 5, 57, 18],
                                stretchX: [[10, 11], [55, 56]],
                                stretchY: [[10, 11]],
                            });
                        }
                    })
            }
        },
    },
};

export default mapFunctionsMixin;
